import { getClient } from '@/lib/restClient';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';
export type MenuManagementMenuUpdateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  brand_category_sort_objects: SortObject[];
};

export const useMenuManagementUpdateBrandMenu = async (
  id: string,
  params: MenuManagementMenuUpdateParams
): Promise<void> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );

  return menuManagementBrandMenuService.update(id, params);
};
